import { FILTER_NAMES } from './FilterNames';

type FilterTable = typeof FILTER_NAMES;

type AdvancedKey = keyof FilterTable['Advanced'];
type BasicKey = keyof FilterTable['Basic'];
type AnyKey = AdvancedKey | BasicKey;

export const getFieldLabel = (
  key: AnyKey,
  isBasicFilter: boolean,
): string | undefined => {
  const filterType = isBasicFilter ? 'Basic' : 'Advanced';
  return FILTER_NAMES[filterType]?.[key as any]?.label;
};

export const getFieldGroup = (key: AdvancedKey): string | undefined => {
  return FILTER_NAMES.Advanced[key]?.group;
};

export const getFieldOperator = (key: BasicKey): string | undefined => {
  return FILTER_NAMES.Basic[key]?.operator;
};
